export const COLORS = {
    btcPrimaryDarkBlue: "#003869",
    btcPrimaryMediumBlue: "#5aa6e7",
    btcPrimaryYellow: "#fbd200",
    btcPrimaryGrey: "#f5f5f5",
    btcSecondaryGradationOne: "#00508c",
    btcSecondaryGradationTwo: "#0078be",
    btcSecondaryGradationThree: "#9ccaf1",
    btcSecondaryGradationFour: "#cee4f8",
    btcSecondaryGrey: "#f0f0f0",
    btcTertiaryGreen: "#c4ce00",
    btcTertiaryPink: "#ff3c8c",
    btcGradientDarkBlue: "#003869",
    btcGradientBlue: "#0f4b8c"
}